import { render, staticRenderFns } from "./LabRequestStatus.vue?vue&type=template&id=571a867e&scoped=true&"
import script from "./LabRequestStatus.vue?vue&type=script&lang=js&"
export * from "./LabRequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./LabRequestStatus.vue?vue&type=style&index=0&id=571a867e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a867e",
  null
  
)

export default component.exports